import React from 'react';
import ReactDOM from 'react-dom/client';
import Page from './components/pages/Page';
import './styles/index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Page />
);